import { render, staticRenderFns } from "./OrderTypeMaintain.vue?vue&type=template&id=2905c92d"
import script from "./OrderTypeMaintain.vue?vue&type=script&lang=js"
export * from "./OrderTypeMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports